import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import ChangeOrderStatus from '../components/ChangeOrderStatus';
import { MdModeEdit } from 'react-icons/md'; 
import { CiTimer } from 'react-icons/ci';
import { MdOutlineDoneOutline } from 'react-icons/md';
import ChangeSalesMan from '../components/ChangeSalesMan';
import { CiDeliveryTruck } from "react-icons/ci";
import { RiRefund2Fill } from "react-icons/ri";
import defaultImage from '../assest/DAWACO_Icon.png'; 
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { HiXCircle } from "react-icons/hi";
import DeleteOrders from '../components/DeleteOrders';
import { FaEye } from 'react-icons/fa6';

const AdminViewUserOrders = () => {
  const { userId } = useParams();
  const location = useLocation();
  const { type } = location.state || {}; 
  const [orders, setOrders] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showChangeSalesMan, setShowChangeSalesMan] = useState(false);
  const [currentSalesman, setCurrentSalesman] = useState(''); 
  const user = useSelector(state => state?.user?.user);
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();


  
  // Default startDate and endDate for the current month
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${SummaryApi.getUserById.url}/${userId}`, {
        method: SummaryApi.getUserById.method,
        credentials: 'include',
      });
      const responseData = await response.json();
      if (responseData.success) {
        setUserDetails(responseData.data || {});
      } else {
        setError(responseData.message);
      }
    } catch (error) {
      
      setError('Error fetching user details');
    } finally {
      setLoading(false);
    }
  };

  const fetchUserOrders = async () => {
    try {
      
  
      const query = new URLSearchParams({
        type,
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : '',
      }).toString();
  
      const response = await fetch(`${SummaryApi.adminViewUserOrders.url}/${userId}?${query}`, {
        method: SummaryApi.adminViewUserOrders.method,
        credentials: 'include',
      });
  
      const responseData = await response.json();
      if (responseData.success) {
        setOrders(responseData.data || []);
      } else {
        setOrders([]);
      }
    } catch (error) {
      setOrders([]);
    }
  };

  useEffect(() => {
    fetchUserDetails();
    fetchUserOrders(); 
  }, [userId]);

  useEffect(() => {
    fetchUserOrders(); 
  }, [startDate, endDate]);

  const handleStatusClick = (orderId, currentStatus) => {
    setSelectedOrderId(orderId);
    setSelectedStatus(currentStatus);
    setShowChangeSalesMan(false); 
  };
  
  const handleChangeSalesManClick = (orderId, salesManName) => {
    setSelectedOrderId(orderId);
    setCurrentSalesman(salesManName || '');
    setShowChangeSalesMan(true);
  };

  const closeModal = () => {
    setSelectedOrderId(null);
    setSelectedStatus('');
    setShowChangeSalesMan(false); 
  };

  const refreshData = async () => {
    await fetchUserOrders(); 
    await fetchUserDetails();
};

const handleViewOrder = (orderId) => {
  navigate(`/admin-panel/adminViewAnOrder/${orderId}/${user?.type}`);
};


useEffect(() => {
  setLoadingPage(true);
  const loadingTimeout = setTimeout(() => {
    
    setLoadingPage(false);
    navigate("/");
  }, 10000); 

  if (user) {
    if (user?.role !== ROLE.ADMIN) {
      navigate('/');
      setLoadingPage(false);
    } 
    else {
      if(user?.type === "Admin"){
          navigate('/admin-panel/all-users');
          setLoadingPage(false);
      }
      else{
          setLoadingPage(false);
          clearTimeout(loadingTimeout);
      }
     
    }
  } 

  // Clear the timeout when the component unmounts or the effect is rerun
  return () => clearTimeout(loadingTimeout);
}, [user, navigate]);

if (loadingPage) {
  return (
      <div className="flex justify-center items-center h-screen">
          <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
  );
}



  return (
    <div className="min-h-[calc(100vh-120px)] flex flex-col">
      {/* User Details Section */}
      <div className="bg-white p-4 mb-4 border border-gray-300 rounded">
        {loading ? (
          <p>جاري التحميل</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <div className="mb-4 p-4 border border-gray-300 bg-gray-100 rounded ">
                    <h2 className="text-xl font-bold mb-2">معلومات المستخدم</h2>
                    {userDetails.profilePic && (
                        <img src={userDetails.profilePic} alt="Profile" className="w-24 h-24 rounded-full" />
                    )}
                    <p className="mb-1"> {userDetails.name || 'N/A'}<strong>: الاسم</strong></p>
                    <p className="mb-1">{userDetails.email || 'N/A'} <strong>: البريد الالكترونى</strong> </p>

                    {type==='Medicine' &&
                    <p className="mb-1">
                        {userDetails?.medicineDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.medicineDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }
                    {type==='Cosmetic' &&
                    <p className="mb-1">
                        {userDetails?.cosmeticDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.cosmeticDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }

                    <p className="mb-1"> {userDetails.shippingAddress || 'N/A'} <strong>: العنوان</strong></p>
                    <p className="mb-1"> {userDetails.mobileNumber || 'N/A'} <strong>: رقم الهاتف المحمول</strong></p>

                </div>
        )}
      </div>

{/* Date Filter Section */}
<div className="flex justify-end items-start mb-4">
  <div className="text-right">
    <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها فواتير المستخدم</h2>

    <div className="flex gap-6 justify-end">
      {/* Start Date */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          تاريخ البداية
        </label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>

      {/* End Date */}
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          تاريخ النهاية
        </label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>
    </div>
  </div>
</div>


      {/* Orders Section */}
<main className="w-full h-full p-4 text-right">
  {orders.length === 0 ? (
    <p>لا يوجد فواتير متاحة في هذه الفتره الزمنية</p>
  ) : (
    orders.map((order, index) => (
      <div key={order._id || index} className="my-6 bg-white p-6 rounded-lg shadow-md">
        <p className="font-medium text-lg text-gray-700">{moment(order.createdAt).format('LLL')}</p>

        <div className="border rounded-lg p-4 mt-4">
        <button onClick={() => handleViewOrder(order._id)} className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center space-x-2">
           <FaEye />
           <span>تفاصيل الطلب</span>
            </button>
            
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
            
            {/* Product Details */}
            <div className="grid gap-4">
              {order.productDetails?.map((product, index) => (
                <div key={product.productId + index} className="flex gap-4 bg-slate-50 p-3 rounded-lg shadow-sm">
                  
                  <img
                    src={product.productImage?.[0] || defaultImage }
                    className="w-28 h-20 bg-slate-200 object-cover rounded-md"
                    alt={product.productName }
                  />
                  <div>
                    <div className="font-semibold text-lg text-gray-800">{product?.productName}</div>
                    <div className="flex items-center gap-4 mt-1">
                      <div className="text-lg text-blue-800">{displayINRCurrency(product?.unitPrice * product?.quantity)}</div>
                      {product?.bonus >0 &&(
                        <p className="text-gray-600">البونص: {product?.bonus}</p>
                      )}
                       <p className="text-gray-600">الكمية: {product?.quantity}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>


            {/* Order Summary */}
           <div className="font-semibold ml-auto w-full lg:w-auto lg:text-lg mt-4 lg:mt-0">


           {order.type==='order'&&
            <div className="mb-2 ml-20">
           <p className="font-medium text-lg">
           <span className="font-semibold text-gray-700">كود الطلب:</span> #{order?.orderCode}
            </p>
            {order.orderSalesManName &&   <p className="font-medium text-lg">
              <span className="font-semibold text-gray-700"></span>  ({order?.orderSalesManName}): تم الطلب بواسطة مندوب المبيعات
              </p>}
               {order.orderSalesManName==='' &&   <p className="font-medium text-lg">
                <span className="font-semibold text-gray-700"></span> تم الطلب بواسطة الصيدلية 
                 </p>}
                 {order.refundAdminId &&   <p className="font-medium text-lg">
                  <span className="font-semibold text-gray-700"></span>  ({order?.refundAdminName}) :تم الرفض بواسطة الادمن  
                  </p>}
                  
                    {order.editedAdminId &&   <p className="font-medium text-lg">
                 <span className="font-semibold text-gray-700"></span>  ({order?.editedAdminName}) :تم التعديل بواسطة الادمن  
                                                </p>}
            </div>} 

            {order.type==='refund'&&
             <div className="mb-2 ml-20">
             <p className="font-medium text-lg">
                <span className="font-semibold text-gray-700">كود العملية (المرتجع):</span> #{order.orderCode}
            </p>

            <p className="font-medium text-lg">
            <span className="font-semibold text-gray-700">مرتجع من الطلب : </span> #{order.refundFromOrderNumber}
            </p>
            {order.refundSalesManId===""&&order.refundAdminId===""&&
            <p className="font-medium text-lg">
            <span className="font-semibold text-gray-700">تم بواسطة الصيدلية </span> 
              </p>}
            {order.refundSalesManId!==""&&
            <p className="font-medium text-lg">
            <span className="font-semibold text-gray-700">تم بواسطة مندوب المبيعات </span> ({order.refundSalesManName})
              </p>}
              {order.refundSalesManId===""&&order.refundAdminId!==""&&
              <p className="font-medium text-lg">
                 <span className="font-semibold text-gray-700">تم بواسطة الادمن </span> ({order.refundAdminName})
                 </p>}
            </div>} 
            
              <div className="flex items-center justify-end text-right mb-6">
                <span className="text-xl font-bold text-blue-800">{displayINRCurrency(order.totalPrice || 0)}</span>
                <span className="block mr-2 text-gray-600">: المبلغ الإجمالي</span>

              </div>
              





              {/* Order Status */}
              <div className="flex items-center justify-end text-right">
                {order.status === 'pending' ? (
                  <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center">
                    <CiTimer className="inline-block mr-2 text-yellow-600 text-2xl" />
                    جاري التحضير
                  </span>
                ) : order.salesManName === '' && order.status === 'accepted' ? (
                  <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center">
                    <CiDeliveryTruck className="inline-block mr-2 text-blue-500 text-2xl" />
                    تم التحضير بانتظار وضع مندوب مبيعات
                  </span>
                ) : order.salesManName !== '' && order.status === 'accepted' ? (
                  <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center">
                    <CiDeliveryTruck className="inline-block mr-2 text-blue-500 text-2xl" />
                    {order.salesManName}: مندوب المبيعات المسؤول
                  </span>
                ) : order.status === 'done' ? (
                  order.type === 'order' ?
                  <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center">
                    <MdOutlineDoneOutline className="inline-block mr-2 text-green-500 text-2xl" />
                    تم استلام الطلب
                  </span>
                  : order.type === 'refund' ?
                  <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center">
                  <RiRefund2Fill className="inline-block mr-2 text-green-500 text-2xl" />
                  تم اعادة الطلب (استرجاع)
                </span>
                :""
                )
                :  order.status === 'refused' ? (
                  <span className="bg-red-100 text-red-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center">
                    <HiXCircle className="inline-block mr-2 text-red-500 text-2xl" />
                   تم رفض الطلب
                  </span>
                ) : (
                  order.status
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-4">
            {  order?.status !== 'refused' &&order?.type === 'order' && (
              <button
                className="bg-blue-100 w-full lg:w-auto p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white mb-2 flex items-center justify-center"
                onClick={() => handleStatusClick(order._id, order.status)}
              >
                <MdModeEdit className="text-xl" />
                <span className="ml-2">تعديل حالة الطلب</span>
              </button>
            )}

            {order.status === 'accepted' && order.salesManName === '' && (
              <button
                className="bg-blue-100 w-full lg:w-auto p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white mb-2 flex items-center justify-center"
                onClick={() => handleChangeSalesManClick(order._id, order.salesManName)}
              >
                <MdModeEdit className="text-xl" />
                <span className="ml-2">وضع مندوب مبيعات مسؤول</span>
              </button>
            )}

            {order.status === 'accepted' && order.salesManName !== '' && (
              <button
                className="bg-blue-100 w-full lg:w-auto p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white mb-2 flex items-center justify-center"
                onClick={() => handleChangeSalesManClick(order._id, order.salesManName)}
              >
                <MdModeEdit className="text-xl" />
                <span className="ml-2">تعديل مندوب مبيعات الحالي</span>
              </button>
            )}
          </div>
        </div>
      </div>
    ))
  )}
</main>

      {/* ChangeOrderStatus Component for Modal */}
      {selectedOrderId && !showChangeSalesMan && (
      <ChangeOrderStatus
        orderId={selectedOrderId}
        currentStatus={selectedStatus}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={type}
      />
    )}

    {/* ChangeSalesMan Component for Modal */}
    {showChangeSalesMan && (
      <ChangeSalesMan
        requestId={selectedOrderId}
        currentSalesman={currentSalesman}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={type}
      />
    )}




    </div>
  );
};

export default AdminViewUserOrders;
